module.exports = __webpack_public_path__ + "bf79cb328f9291fb0d1543b24b3bbb23.gif";